import { KeyValueStore } from '../utils/keyValue';
import { userStoreAPI } from '@fluke/baseline-client-apis';
export class UserKeyValueStore extends KeyValueStore {
  async get(key) {
    try {
      const value = await userStoreAPI.get();
      return value[key];
    } catch (error) {
      return undefined;
    }
  }

  set(key, value) {
    userStoreAPI.set(key, value);
  }

  remove(key) {
    userStoreAPI.delete(key);
  }
}
